// extracted by mini-css-extract-plugin
var _1 = "MessageComposer-module__actions--H2w4G";
var _2 = "MessageComposer-module__actionsLeft--nm_oG";
var _3 = "MessageComposer-module__actionsRight--XYCaB";
var _4 = "MessageComposer-module__animateUploadProgressBarWidth--kl47_";
var _5 = "MessageComposer-module__animatedBackground--_sEpW";
var _6 = "MessageComposer-module__iconButton--PIbu2";
var _7 = "MessageComposer-module__inputContainer--XzRhr";
var _8 = "MessageComposer-module__messageComposer--L0809";
var _9 = "MessageComposer-module__selectableMenuItemCheckIcon--iDIYr";
var _a = "MessageComposer-module__selected--z2paR";
var _b = "MessageComposer-module__stopButton--UwE59";
export { _1 as "actions", _2 as "actionsLeft", _3 as "actionsRight", _4 as "animateUploadProgressBarWidth", _5 as "animatedBackground", _6 as "iconButton", _7 as "inputContainer", _8 as "messageComposer", _9 as "selectableMenuItemCheckIcon", _a as "selected", _b as "stopButton" }
